import React, { useEffect, useState } from "react";
import "./style.css";
import { Button, Rate } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeOutlined, HeartFilled, HeartOutlined } from "@ant-design/icons";

export default function FavoriteCard({
  data,
  is_fav,
  onClickRemoveFavorite,
  onClickAddFavorite,
}) {
  const navigate = useNavigate();

  const [isReact, setIsReady] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsReady(true);
    }, 1000);
  }, [data.profile_url]);

  return (
    <div className="favorite-card-contaier" style={{ overflow: "hidden" }}>
      {data.profile_url && (
        <div
          style={{
            backgroundImage: `url(${data.profile_url})`,
            height: 200,
            width: "100%",
            backgroundPosition: isReact ? "center" : "center",
            backgroundSize: isReact ? "cover" : "cover",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}
      <div style={{ padding: 20, position: "relative" }}>
        <div style={{ position: "absolute", right: 15, top: 15 }}>
          {is_fav ? (
            <HeartFilled
              onClick={() => onClickRemoveFavorite(data.id)}
              style={{ fontSize: 20, color: "red" }}
            />
          ) : (
            <HeartOutlined
              onClick={() => onClickAddFavorite(data.id)}
              style={{ fontSize: 20 }}
            />
          )}
        </div>
        {/* <div style={{ alignItems: "center", display: "flex", gap: 5 }}>
          <Rate value={data?.average_rate} />
          <div>({data?.review_count} รีวิว)</div>
        </div> */}
        <h2 style={{ marginTop: 15 }}>{data.display_name}</h2>
        <div style={{ marginTop: -5, marginBottom: 5 }}>
          หมายเลขแคดดี้ : {data.caddy_number}
        </div>
        <div style={{ color: "#007AFF", marginBottom: 10 }}>
          {data.golf_course_name}
        </div>

        {/* Profile Images Gallery */}
        {(data.profileFile || data.file_uploads) && (
          <div style={{ marginBottom: 15 }}>
            <div style={{ fontSize: 12, color: "#666", marginBottom: 8 }}></div>
            <div
              style={{
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {data?.profileFile && typeof data.profileFile === "string" && (
                <div style={{ position: "relative" }}>
                  <img
                    src={data.profileFile}
                    alt="Profile"
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: "cover",
                      borderRadius: "50%",
                      border: "2px solid #52c41a",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
              )}
              {/* File Uploads Images */}
              {data?.file_uploads &&
                Array.isArray(data.file_uploads) &&
                data.file_uploads.length > 0 &&
                data.file_uploads.map((upload, index) => (
                  <div key={`upload-${index}`} style={{ position: "relative" }}>
                    <img
                      src={upload.url || upload.file_path || upload}
                      alt={`Upload ${index + 1}`}
                      style={{
                        width: 45,
                        height: 45,
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "2px solid #1890ff",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        )}

        <Button
          style={{ width: "100%" }}
          type="primary"
          onClick={() => navigate(`/book_caddy/${data.id}`)}
        >
          <div>
            <EyeOutlined /> ดูโปรไฟล์
          </div>
        </Button>
      </div>
    </div>
  );
}
